import { loadable } from '@elliemae/pui-app-sdk';

export const LoadableRulesBuilder = loadable(
  () =>
    import(
      /* webpackChunkName: "schema" */ /* webpackPrefetch: true */ './index'
    ),
  null, // use wait message from html
);
